import SaleList from "./saleList.jsx";

export default SaleList;
